// 负荷分析图表配置

// 电表颜色配置（参考负荷跟踪）
export const meterColors = ['#3A68FF', '#FF7A45', '#10B981', '#FF6B6B', '#8DD3F5', '#B8E5D6']

// 计算Y轴最大值
export const calculateYAxisMax = (seriesData, defaultMax = 500, interval = 50) => {
  const allValues = seriesData.flatMap(item => item.data).filter(v => v !== null && v !== undefined)
  const maxPower = allValues.length > 0 ? Math.max(...allValues) : defaultMax
  return Math.ceil(maxPower / interval) * interval
}

// 生成series配置
export const generateSeriesConfig = (seriesData, categories) => {
  return seriesData.map((item, index) => {
    return {
      name: item.name,
      type: 'line',
      data: item.data.map((value, idx) => {
        return [categories[idx], value]
      }),
      smooth: true,
      symbol: 'circle',
      symbolSize: 4,
      showSymbol: false, // 默认不显示数据点，鼠标悬停时显示
      lineStyle: {
        color: meterColors[index % meterColors.length],
        width: 2
      },
      itemStyle: {
        color: meterColors[index % meterColors.length]
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: meterColors[index % meterColors.length] + '40' },
            { offset: 1, color: meterColors[index % meterColors.length] + '05' }
          ]
        }
      }
    }
  })
}

// 基础图表配置
export const getBaseChartConfig = (legendData, yAxisMax) => {
  return {
    legend: {
      show: true,
      top: 0,
      right: 12,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      textStyle: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        color: 'rgba(46, 46, 46, 0.70)'
      },
      data: legendData
    },
    grid: {
      top: 40,
      bottom: 20,
      left: 50,
      right: 20,
      containLabel: true
    },
    xAxis: {
      type: 'time',
      boundaryGap: false,
      axisLabel: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)',
        formatter: (value) => {
          const date = new Date(value)
          return `${date.getMonth() + 1}-${date.getDate()}`
        }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      name: '功率(kW)',
      nameLocation: 'end',
      nameTextStyle: {
        align: 'center',
        color: 'rgba(46, 46, 46, 0.70)',
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        padding: [0, 0, 0, 35]
      },
      min: 0,
      max: yAxisMax,
      interval: yAxisMax / 5,
      axisLabel: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)',
        formatter: (value) => {
          return Math.round(value).toString()
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(106, 114, 124, 0.1)',
          type: 'dashed'
        }
      },
      axisLine: {
        show: false
      }
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.90)',
      borderColor: 'transparent',
      borderRadius: 16,
      extraCssText: 'backdrop-filter: blur(4px); box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);',
      textStyle: {
        color: '#2E2E2E',
        fontFamily: "HarmonyOS Sans SC",
        fontSize: 14
      },
      axisPointer: {
        type: 'line',
        label: {
          backgroundColor: '#777'
        }
      },
      formatter: (params) => {
        if (!params || params.length === 0) return ''
        const param = params[0]
        const time = param.axisValue

        let timeStr = ''
        const date = (time instanceof Date) ? time : new Date(time)
        if (!isNaN(date.getTime())) {
          const pad = (n) => String(n).padStart(2, '0')
          timeStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
        } else {
          timeStr = String(time)
        }

        let result = `<div style="margin-bottom: 8px; font-size: 12px; color: #8b93aa;">${timeStr}</div>`
        params.forEach(item => {
          if (item.value && item.value[1] !== null && item.value[1] !== undefined) {
            const value = item.value[1]
            result += `
              <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: 4px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <div style="width: 8px; height: 8px; border-radius: 50%; background: ${item.color};"></div>
                  <span>${item.seriesName}</span>
                </div>
                <span style="font-weight: 500;">${Number(value).toFixed(2)} kW</span>
              </div>
            `
          }
        })
        return result
      }
    }
  }
}

// 生成完整的图表配置
export const generateChartOption = (categories, seriesData) => {
  const legendData = seriesData.map(item => item.name)
  const series = generateSeriesConfig(seriesData, categories)
  const yAxisMax = calculateYAxisMax(seriesData)
  const baseConfig = getBaseChartConfig(legendData, yAxisMax)

  return {
    ...baseConfig,
    series: series
  }
}

// 全屏对话框配置
export const fullscreenDialogConfig = {
  maxWidth: 1400,
  maxHeight: 900,
  widthRatio: 0.9,
  heightRatio: 0.9
}

